import React, {
} from 'react';
import {
  Paper, Table
} from '@mui/material';
import Box from '@mui/material/Box';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {CheckRounded, CloseRounded} from "@mui/icons-material";
import {formatPrice} from "../../../../reducer/actions/formatPrice";
import {useStateContext} from "../../../../hooks/useStateContext";
import { formatNumber } from '../../../../reducer/actions/formatNumber';
import { ImageSlider } from '../ImageSlider';

interface Props {
  row: any;
  size: any;
  eurValue: any;
}

export const ActivityPriceTable: React.ComponentType<Props> = ({
                                                                 row,
                                                                 size,
                                                                 eurValue
                                                               }) => {

  const pricePP = row[`size_${size}`] ? row[`size_${size}`] : 0;
  const priceTotal = pricePP * size;

  const commissionPP = row[`commission_${size}`] ? row[`commission_${size}`] : 0;

  const currency = row?.currency ? row?.currency.name : 'EUR';

  const prices: any = {
    price_pp: {
      eur: 0,
      huf: 0,
    },
    price_total: {
      eur: 0,
      huf: 0,
    },
    commission_total: {
      huf: 0,
    },
  };

  if (currency === 'EUR') {
    prices.price_pp.eur = pricePP;
    prices.price_pp.huf = pricePP * eurValue;
    prices.price_total.eur = priceTotal;
    prices.price_total.huf = priceTotal * eurValue;
  } else {
    prices.price_pp.eur = pricePP / eurValue;
    prices.price_pp.huf = pricePP;
    prices.price_total.eur = priceTotal / eurValue;
    prices.price_total.huf = priceTotal;
  }

  prices.commission_total.huf = commissionPP;

  return (
    <>
      <Box
        component={Paper}
        sx={{
        p: '5px',
        '& .MuiTableCell-root': {
          p: '5px',
          fontSize: '12px',
        }
      }}>

        <ImageSlider images={row?.activity?.images} />

        <Table key={row?.id}>
          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Includes
            </TableCell>
            <TableCell>
              <div dangerouslySetInnerHTML={{__html: row?.activity?.includes}}>

              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Description
            </TableCell>
            <TableCell>
              <div dangerouslySetInnerHTML={{__html: row?.activity?.description_en}}>

              </div>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Guide Info
            </TableCell>
            <TableCell>
              <div dangerouslySetInnerHTML={{__html: row?.activity?.guide_infos}}>

              </div>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Guide Schedule Info
            </TableCell>
            <TableCell>
              <div dangerouslySetInnerHTML={{__html: row?.activity?.guide_schedule_infos}}>

              </div>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Venue
            </TableCell>
            <TableCell>
              {row.venues.map((item: any) => {
                return <div>
                  {item?.name} {item?.address_line1}
                </div>;
              })}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Bus
            </TableCell>
            <TableCell>

              {row?.activity?.bus_included ? (
                <CheckRounded color={'success'} fontSize={'small'}/>
              ) : (
                <CloseRounded color={'error'} fontSize={'small'}/>
              )}

            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Price
            </TableCell>
            <TableCell>
              <div>Per
                Person: <b>{formatPrice(prices.price_pp.huf)}</b> / <b>{formatPrice(prices.price_pp.eur, true)}</b>
              </div>
              <div>Total: <b>{formatPrice(prices.price_total.huf)}</b> / <b>{formatPrice(prices.price_total.eur, true)}</b>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{
              width: '60px'
            }}>
              Comm.
            </TableCell>
            <TableCell>
              <div>Total: <b>{formatNumber(prices.commission_total.huf)} HUF</b>
              </div>
            </TableCell>
          </TableRow>
        </Table>
      </Box>
    </>
  );
};
